<template>
  <!-- THIS IS JUST A PLACEHOLDER FOR NOW, HAS A BUNCH OF LEFTOVER STRIPE STUFF -->
  <div class="payment-view">
    <section class="payment">
      <section class="payment-item billing-details" v-show="true">
        <div class="stripe-inline-container" :class="{'submitting' : submittingPayment }">
          <fieldset>
            <p><strong>Credit Card, Debit Card or Account 2 Account</strong></p>
            <p>Pay with Visa, Mastercard or login to your bank through account2account to load an automatic transfer payment from your selected account.</p>
            <div class="stripe-inline-container__form">

              <div class="columns is-vcentered mt-1">
                <div class="column is-4 has-text-centered-mobile">
                    <img class="icon-windcave" src="/assets/images/windcave.png" />
                </div>
                <div class="column is-8" align="right">
                  <div class="columns is-multiline is-mobile is-centered is-vcentered">
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-mastercard" src="/assets/images/visa_modern.png" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-visa" src="/assets/images/policymastercard.jpg" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-account2account" src="/assets/images/account2account-logo.png" /></div>
                  </div>
                </div>
                <div class="column has-text-right is-hidden-mobile">
                  
                </div>
              </div>

              <!--      Pay from card on file   -->
              <div v-if="isAltFlow" class="columns">
                <div class="column">
                  <strong><InlineText
                      v-if="getAmountToPay > 0"
                      label="Payment required"
                      tooltip="This is the total additional premium to pay for the change to your policy."
                      />
                    <InlineText
                        v-if="getAmountToPay <= 0"
                        label="Refund"
                        tooltip="We will refund this back onto your credit card or bank account."
                      /></strong>
                  <p v-if="getAmountToPay >= 0">NZD {{ getAmountToPay|toCurrency }}</p>
                  <p v-else>NZD {{ (getAmountToPay*-1)|toCurrency }}</p>
                </div>
                <div class="column has-text-right is-hidden-mobile">
                  
                </div>
              </div>

            </div>

          </fieldset>
        </div>
      </section>
    </section>

    <section class="notification is-success mt-5" v-show="this.paymentSuccess">
      successful, confirming policy...
    </section>
  </div>
</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import { mapGetters } from 'vuex'
import store, { api } from '../../store/store.js';

export default {
  name: 'Payment',
  data() {
    return {
      card: null,
      elementsError: null,
      submittingPayment: true,
      paymentSuccess: false,
      modalOpen: false,
      txnid: null,
    };
  },
  created() {

  },
  beforeDestroy() {
    
  },
  computed: {
    getAmountToPay: function(){
      if( "vehicle_quote_adjustment_raw" in this.answers[this.getStep('Vehicle.Quote')] ){
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw;
      } else {
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw;
      }
    },
    ...mapGetters({
      client: 'client',
      answers: 'flattenedAnswers',
      schemaHash: 'getSessionSchemaHash',
      getStep: 'getStep',
      isAltFlow: 'isAltFlow',
      isRenewFlow: 'isRenewFlow',
    }),
  },
  watch: {
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">

.icon-windcave {
  width: 140px;
  margin-right: 5px;
}
.icon-account2account {
  width: 145px;
  margin-right: 5px;
}
.icon-mastercard, .icon-visa {
  width: 60px;
  margin-right: 5px;
}

</style>
